import { ComponentPropsWithRef, MouseEventHandler, RefObject } from "react"

import { classNames } from "../../../../lib/classNames"

export type TextButtonSize = "sm" | "md" | "lg"

interface TextButtonProps extends ComponentPropsWithRef<"button"> {
  enableClickPropagation?: boolean
  size?: TextButtonSize
  ref?: RefObject<HTMLButtonElement | null>
}

export const TextButton = (props: TextButtonProps) => {
  const {
    ref,
    children,
    className,
    onClick,
    enableClickPropagation = false,
    size = "md",
    ...otherProps
  } = props

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (!enableClickPropagation) {
      event.stopPropagation()
    }
    if (onClick) {
      onClick(event)
    }
  }

  const sizeClasses = {
    sm: "text-body",
    md: "text-body-lg",
    lg: "text-title-body",
  } as const

  return (
    <button
      ref={ref}
      type="button"
      className={classNames(
        "text-v2-foreground-primary hover:not-disabled:text-v2-foreground-primary-strong disabled:text-v2-foreground-primary-disabled whitespace-nowrap font-medium underline",
        sizeClasses[size],
        className
      )}
      onClick={handleClick}
      {...otherProps}
    >
      {children}
    </button>
  )
}

TextButton.displayName = "TextButton"
